export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CustomCoffeeSelector.vue?vue&type=template&id=1dd0b7c4&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/MenuBuilder/CustomCoffeeSelector.vue?vue&type=template&id=1dd0b7c4&
// module id = 144
// module chunks = 3